import {lazy} from 'react'

// Async Handler Components

export const ElaAssessmentReportHandler = lazy(
  () => import('../../../../../ela/assessment/components/assessment-report'),
)

export const ElaAssessmentSessionReportHandler = lazy(
  () => import('../../../../../ela/assessment/components/assessment-session-report'),
)

export const ElaAssignmentSessionHistoryReportHandler = lazy(
  () => import('../../../../../ela/common/components/assignment-session-history-report'),
)

export const ElaGroupsReportHandler = lazy(
  () => import('../../../../../ela/common/components/groups-report'),
)

export const ElaReportCardViewHandler = lazy(
  () => import('../../../../../ela/common/components/report-cards/ela-report-card-view-handler'),
)

export const ElaReportCardsHandler = lazy(
  () => import('../../../../../ela/common/components/report-cards'),
)

export const PerformanceByStandardReportHandler = lazy(
  () => import('../../../../../ela/common/components/performance-by-standard-report'),
)

export const PrintElaReportCardsHandler = lazy(
  () => import('../../../../../ela/common/components/report-cards/print-ela-report-cards-handler'),
)

export const ElaStandardStudentReportHandler = lazy(
  () => import('../../../../../ela/common/components/standard-student-report'),
)

export const ElaLevelsReportHandler = lazy(() => import('../../../../../ela/levels-report'))

export const ElaAssessmentAssignmentsReportHandler = lazy(
  () => import('../../../../../ela/assessment/components/assessment-assignments-report'),
)

export const ElaWordStudyMatrixReportHandler = lazy(
  () => import('../../../../../ela/word-study/components/word-study-matrix-report'),
)

export const ElaSkillsProgressReportHandler = lazy(
  () => import('../../../../../ela/skills-progress'),
)

export const ElaAdaptiveSkillsReportHandler = lazy(
  () => import('../../../../../ela/adaptive-skills/components/adaptive-skills-report'),
)

export const ElaTargetedSkillsReportHandler = lazy(
  () => import('../../../../../ela/targeted-skills/components/targeted-skills-report'),
)

export const ElaFocusSkillsReportHandler = lazy(
  () => import('../../../../../ela/focus-skills/components/focus-skills-report'),
)

export const ElaFocusSkillsAssignmentReportHandler = lazy(
  () => import('./../../../../../ela/focus-skills/components/focus-skills-assignment-report'),
)

export const ElaTargetedSkillsAssignmentReportHandler = lazy(
  () => import('../../../../../ela/targeted-skills/components/targeted-skills-assignment-report'),
)

export const WordStudySessionReportHandler = lazy(
  () => import('../../../../../ela/word-study/components/word-study-session-report'),
)

export const ElaArticleReadingAssignmentSessionReportHandler = lazy(
  () => import('../../../../../ela/articles/components/reading-assignment-report'),
)

export const ElaWritingAssignmentReportHandler = lazy(
  () => import('../../../../../ela/articles/components/writing-assignment-session-report'),
)

export const ElaArticleClassActivityHandler = lazy(
  () => import('../../../../../ela/articles/components/article-class-activity'),
)

export const ElaCorrelationPage = lazy(
  () => import('../../../../../ela/text-levels/components/ela-correlation'),
)
